import styled from 'styled-components';

const SrOnly = styled.section`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

interface PdpCrawlableContentProps {
  purchaseBenefits: string[];
  relatedProducts: string[];
  warrantyDuration: string;
  warrantyExtDuration: string;
}

export const PdpCrawlableContent = ({
  purchaseBenefits,
  relatedProducts,
  warrantyDuration,
  warrantyExtDuration,
}: PdpCrawlableContentProps) => {
  const hasBenefits = purchaseBenefits.length > 0;
  const hasRelated = relatedProducts.length > 0;
  const hasWarranty = !!warrantyDuration;

  if (!hasBenefits && !hasRelated && !hasWarranty) {
    return null;
  }

  return (
    <SrOnly aria-label='Additional product information'>
      {hasBenefits && (
        <>
          <h2>Online Purchase Benefits</h2>
          <ul>
            {purchaseBenefits.map((benefit) => (
              <li key={benefit}>{benefit}</li>
            ))}
          </ul>
        </>
      )}

      {hasWarranty && (
        <>
          <h2>Warranty</h2>
          <p>
            This watch comes with a {warrantyDuration}-year international
            warranty.
            {warrantyExtDuration &&
              ` Warranty can be extended up to ${warrantyExtDuration} years by registering online.`}
          </p>
        </>
      )}

      {hasRelated && (
        <>
          <h2>Related Products</h2>
          <ul>
            {relatedProducts.map((sku) => (
              <li key={sku}>{sku}</li>
            ))}
          </ul>
        </>
      )}
    </SrOnly>
  );
};
